define('lq/events/actions/rssCommand',[
    'lq/events/actions/eventAction',
    'jquery',
    'lq'
], function (EventAction, $, lq) {
    'use strict';

    function RssCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(RssCommand, EventAction);

    RssCommand.typeName = 'RssCommand';

    RssCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    RssCommand.prototype.execute = function (continuation) {
        // we can't use a POST since people should be able to directly link to the export

        var queryString = {
            rssId: this.eventData.command,
            parameters: JSON.stringify(this.piping.parameters.getNonSystemParameters())
        };
        window.location = this.piping.url.prepare(lq.getTenantUrl('Export/Rss'), queryString);

        continuation();
    };

    return RssCommand;
});
